import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
export class HelperFunctions {
    constructor(private translate: TranslateService) {

    }
    confirmText = this.translate.instant('ok');
    cancelButtonText = this.translate.instant('no');
    presentAlert(type: any, title: string, text?: string, html?: string,
                 showCancelButton = true, showConfirmButton = true, width?: any, height?: any): Promise<any> {
              if (showCancelButton && showConfirmButton) {
                this.confirmText = this.translate.instant('yes');
                this.cancelButtonText = this.translate.instant('no');
              } else {
                this.confirmText = this.translate.instant('ok');
              }
              return Swal.fire({
                // title,
                text,
                html,
                type,
                showConfirmButton,
                showCancelButton,
                customClass: 'swal-wide',
                width: width ? width : '',
                // height: height ? height : '',
                // imageSize: '20x20',
                // imageWidth: 600,
                // imageHeight: 600,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.confirmText,
                cancelButtonText: this.cancelButtonText
              });
    }

    presentAlertLoader(target = 'body') {
        return Swal.fire({
            target: target === 'body' ? 'body' : document.getElementById(target),
            background: 'unset',
            html: '<img src="assets/images/loading.svg">',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false
        });
    }

    presentAlert2(type: any, title: string, text?: string, html?: string, showCancelButton = true): Promise<any> {
        return Swal.fire({
            title,
            text,
            html,
            type,
            showCancelButton,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.confirmText,
            cancelButtonText: this.cancelButtonText
        });
    }
    presentAlertWithInput(type: any, title: string, text?: string, inputType: string = 'text', inputPlaceholder?: string): Promise<any> {
        return Swal.fire({
            type,
            title,
            text,
            input: inputType as any,
            inputPlaceholder: inputPlaceholder || '',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translate.instant('ok'),
            cancelButtonText: this.translate.instant('cancel'),
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return this.translate.instant('field_required') || 'This field is required';
                }
            }
        });
    }
    presentToast(severity = 'error', summary = '', detail = '') {
        // this.messageService.add({severity, summary: this.translate.instant(summary), detail: this.translate.instant(detail)});
    }
    close() {
        Swal.close();
    }
}
